export default "\r\n<iframe src=\"../assets/Novedades.pdf\" class=\"modalPdf\" ></iframe>\r\n\r\n\r\n  "